/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type UpdateTeamAuthTeamsResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class UpdateTeamAuthTeamsResponse429ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateTeamAuthTeamsResponse429ResponseBodyData;

  constructor(
    err: UpdateTeamAuthTeamsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateTeamAuthTeamsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type UpdateTeamAuthTeamsResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class UpdateTeamAuthTeamsResponse409ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateTeamAuthTeamsResponse409ResponseBodyData;

  constructor(
    err: UpdateTeamAuthTeamsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateTeamAuthTeamsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type UpdateTeamAuthTeamsResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class UpdateTeamAuthTeamsResponse404ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateTeamAuthTeamsResponse404ResponseBodyData;

  constructor(
    err: UpdateTeamAuthTeamsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateTeamAuthTeamsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type UpdateTeamAuthTeamsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class UpdateTeamAuthTeamsResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateTeamAuthTeamsResponseResponseBodyData;

  constructor(
    err: UpdateTeamAuthTeamsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateTeamAuthTeamsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type UpdateTeamAuthTeamsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class UpdateTeamAuthTeamsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateTeamAuthTeamsResponseBodyData;

  constructor(
    err: UpdateTeamAuthTeamsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateTeamAuthTeamsResponseBody";
  }
}

/**
 * Bad request
 */
export type UpdateTeamResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class UpdateTeamResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateTeamResponseBodyData;

  constructor(
    err: UpdateTeamResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateTeamResponseBody";
  }
}

/** @internal */
export const UpdateTeamAuthTeamsResponse429ResponseBody$inboundSchema:
  z.ZodType<UpdateTeamAuthTeamsResponse429ResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new UpdateTeamAuthTeamsResponse429ResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type UpdateTeamAuthTeamsResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateTeamAuthTeamsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    UpdateTeamAuthTeamsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateTeamAuthTeamsResponse429ResponseBody
  > = z.instanceof(UpdateTeamAuthTeamsResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateTeamAuthTeamsResponse409ResponseBody$inboundSchema:
  z.ZodType<UpdateTeamAuthTeamsResponse409ResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new UpdateTeamAuthTeamsResponse409ResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type UpdateTeamAuthTeamsResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateTeamAuthTeamsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    UpdateTeamAuthTeamsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateTeamAuthTeamsResponse409ResponseBody
  > = z.instanceof(UpdateTeamAuthTeamsResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateTeamAuthTeamsResponse404ResponseBody$inboundSchema:
  z.ZodType<UpdateTeamAuthTeamsResponse404ResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new UpdateTeamAuthTeamsResponse404ResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type UpdateTeamAuthTeamsResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateTeamAuthTeamsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    UpdateTeamAuthTeamsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateTeamAuthTeamsResponse404ResponseBody
  > = z.instanceof(UpdateTeamAuthTeamsResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateTeamAuthTeamsResponseResponseBody$inboundSchema: z.ZodType<
  UpdateTeamAuthTeamsResponseResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new UpdateTeamAuthTeamsResponseResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type UpdateTeamAuthTeamsResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateTeamAuthTeamsResponseResponseBody$outboundSchema: z.ZodType<
  UpdateTeamAuthTeamsResponseResponseBody$Outbound,
  z.ZodTypeDef,
  UpdateTeamAuthTeamsResponseResponseBody
> = z.instanceof(UpdateTeamAuthTeamsResponseResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const UpdateTeamAuthTeamsResponseBody$inboundSchema: z.ZodType<
  UpdateTeamAuthTeamsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new UpdateTeamAuthTeamsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type UpdateTeamAuthTeamsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateTeamAuthTeamsResponseBody$outboundSchema: z.ZodType<
  UpdateTeamAuthTeamsResponseBody$Outbound,
  z.ZodTypeDef,
  UpdateTeamAuthTeamsResponseBody
> = z.instanceof(UpdateTeamAuthTeamsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const UpdateTeamResponseBody$inboundSchema: z.ZodType<
  UpdateTeamResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new UpdateTeamResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type UpdateTeamResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateTeamResponseBody$outboundSchema: z.ZodType<
  UpdateTeamResponseBody$Outbound,
  z.ZodTypeDef,
  UpdateTeamResponseBody
> = z.instanceof(UpdateTeamResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
